(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/payment-history.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/payment-history.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardHeader = _svs$ui$ReactCard.CardHeader;
const Loader = svs.components.ReactLoader.Loader;
const dialog = svs.components.dialog;
const PaymentHistory = () => {
  const _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    clubs = _React$useState2[0],
    setClubs = _React$useState2[1];
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    error = _React$useState6[0],
    setError = _React$useState6[1];
  const _svs$grassroots_partn = svs.grassroots_partner.usePaymentHistory(),
    getHightchartOptions = _svs$grassroots_partn.getHightchartOptions;
  const displayFetchError = () => {
    setError(true);
    const branding = svs.core.detect.tenant('tb') ? dialog.branding.TUR : dialog.branding.SPORT;
    dialog.api.add(new dialog.Confirm({
      branding,
      type: dialog.type.ERROR,
      title: 'Något gick fel!',
      message: [{
        type: dialog.message.TEXT,
        text: 'Hämtning av utbetalningshistorik misslyckades'
      }],
      actions: [{
        title: 'STÄNG'
      }]
    }));
  };
  React.useEffect(() => {
    setError(false);
    const options = {
      method: 'GET',
      path: '/partner/1/sponsorship/receiverinfointernal'
    };
    svs.core.jupiter.get(options, (data, status) => {
      if (status === 'success') {
        setClubs(data.receivers);
      } else {
        displayFetchError();
      }
      setLoading(false);
    }, () => {
      setLoading(false);
      displayFetchError();
    });
  }, []);
  return React.createElement("div", null, !error && (loading ? React.createElement(Loader, null) : React.createElement(Card, null, React.createElement(CardHeader, {
    align: "center"
  }, React.createElement("h5", {
    className: "card-header-title"
  }, "Utbetalningar")), React.createElement("div", {
    className: "grid-row padding-2"
  }, clubs.map(club => React.createElement("div", {
    className: "col-xs-12 col-md-6 padding-2",
    key: club.id
  }, React.createElement(svs.components.libs.ReactHighcharts, {
    highcharts: svs.components.libs.Highcharts,
    options: getHightchartOptions(club)
  })))))));
};
svs.grassroots_partner.PaymentHistory = PaymentHistory;

 })(window);